import React from 'react';
import Navigation from '../NavigationItems/NavigationItems';
import Logo from '../../Logo/Logo';
import Aux from '../../../Hoc/Aux/Aux';
import classes from './SideDrawer.css';
import Backdrop from '../../UI/BackDrop/BackDrop';


const sideDrawer = (props) => {
    let attachedClasses = [classes.SideDrawer, classes.Close];
    if (props.open) {
        attachedClasses = [classes.SideDrawer, classes.Open];
    }
    return (
        <Aux>
            <Backdrop  show={props.open} clicked={props.closed}/>
            <div className={attachedClasses.join(' ')}>
                <div className={classes.Logo}>
                    <Logo />
                </div>
                <nav>
                    <Navigation />
                </nav>
            </div>
        </Aux>
    )
};

export default sideDrawer;


// WEBPACK FOOTER //
// ./src/Components/Navigation/SideDrawer/Sidedrawer.js